import { AccessToken, StatusMsg } from './accesstoken';
import { Component, OnInit } from '@angular/core';
import { Application } from '../../application';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestapiService } from '../services/restapi.service';
import { ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import amplitude from 'amplitude-js';

/*
Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Malekar
*/
@Component({
  selector: 'app-newrequest',
  templateUrl: './newrequest.component.html',
  styleUrls: ['./newrequest.component.css'],
})
export class NewrequestComponent implements OnInit {
  [x: string]: any;
  
  uploadForm: FormGroup;
  submitted = false;
  showsuccess = false;
  showSuccessMessage: string;
  userName: any;
  responseMesage: string;
  showErrorMessage: string;
  showerror: boolean;
  authCode: any;
  start = false;
  authUserData: any;
  file_name : String ="No file chosen";
  public  instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");

  constructor(
    private formBuilder: FormBuilder,
    private apiService: RestapiService,
    private httpClient: HttpClient,
    private router: ActivatedRoute,
    public googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {

    this.showsuccess = false;
    this.createForm();
    const hostname = window.location.hostname;

    if (hostname === 'localhost') {
       localStorage.setItem('NAME', 'Ajinkya Bijwe');
      localStorage.setItem('EMAIL', 'abijwe@cisco.com');
     }
    if (!localStorage.hasOwnProperty("TOKEN")) {
      localStorage.setItem('TOKEN', '');
    }
    if (!localStorage.hasOwnProperty("TOKEN_EXPIRATION_SECONDS")) {
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS', '');
    } 
    if(this.calculateTokenSeconds() > 3600){
      localStorage.setItem('TOKEN', '');
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS','');
    }
    if(isNaN(this.calculateTokenSeconds())){
      localStorage.setItem('TOKEN', '');
    }


    const self = this;
     self.router.queryParams.subscribe((params) => {
       self.authCode = params.code;
       if (
        !isNullOrUndefined(self.authCode) &&
         self.authCode !== '' &&
         localStorage.getItem('TOKEN')===''
       ) {
         self.authenticate();
         console.log('first authenticate');
       } else {
         self.initMethods();
         console.log('first initMethods');
       }
     });

  

    // this.googleAnalyticsFunction('Support','New Application Request','New Application Request');

  }
  googleAnalyticsFunction(actionName : string ,category : string, eventName : string,eventLabel : string){

    this.googleAnalyticsService.eventEmitter(
      actionName ,      //eventName -> Partner Help
      category,       //evtCategory ->Menu
      eventName,    //evtAction -> Sales
      eventLabel, //evtLabel -> Partner Help
      1           //evtValue
    );
  }

  authenticate() {
    this.start = true;
    const startTime = new Date().getTime();
    this.apiService.getAccessTokenWithAuthCode(this.authCode).subscribe(
      (resp) => {
        let data: any;
        data = resp.body;
        localStorage.setItem('TOKEN', data.access_token);
        localStorage.setItem('TOKEN_EXPIRATION_SECONDS', startTime + "");
        this.apiService.getUserInfo().subscribe((resp) => {
          this.authUserData = resp.body;
          localStorage.setItem('NAME', this.authUserData.fullname);
          localStorage.setItem('EMAIL', this.authUserData.email);
          this.uploadForm.controls.userName.setValue(
            this.authUserData.fullname
          );
          this.uploadForm.controls.userEmail.setValue(this.authUserData.email);
        });
        const self = this;
        self.start = false;
      },
      (err) => {
        this.start = false;
        console.log(err);
        if (err.status === 500) {
          alert(
            'There is a temporary Infra issue. Please try after some time/try opening the page in new browser. If still issue exists, please contact support team'
          );
        }
      }
    );
  }
    initMethods() {
    if (localStorage.getItem('TOKEN')==='') {
      this.apiService.getAuthCodeUrl().subscribe((resp) => {
        let url: string;
        let result: any;
        result = resp.body;
        url = result.message;
        window.location.href = url;
      });
    } else {

      this.uploadForm.controls.userName.setValue(localStorage.getItem('NAME'));
      this.uploadForm.controls.userEmail.setValue(localStorage.getItem('EMAIL'));

    }
  }

  calculateTokenSeconds() {
    var startDate = localStorage.getItem('TOKEN_EXPIRATION_SECONDS');//1662020766029
    // Do your operations
    var endDate = new Date();
    var seconds = (endDate.getTime() - parseInt(startDate)) / 1000;
    console.log('seconds',seconds);
    return seconds;
  }

  onFileSelect(event: any) {
    for (let i = 0; i < event.target.files.length; i++) {
      debugger
      const file = event.target.files[0];
      this.uploadForm.get('pcapFile')!.setValue(file);
      this.file_name=file.name;
    }
  }
  onSubmit() {
    this.submitted = true;
    if (this.uploadForm.invalid) {
      return;
    }

    if(this.calculateTokenSeconds() > 3600){
      localStorage.setItem('TOKEN', '');
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS','');
      if (this.authCode != null && this.authCode !== '' && localStorage.getItem('TOKEN')===''){
        alert('Session expired, Please submit request again.');
        console.log("initMethods");
        this.initMethods();   
      }
    }
    
    const formData = new FormData();
    const jsonData = this.uploadForm.value;
    delete jsonData.pcapFile;
    //delete jsonData.userEmail;
    
     //Request Submitted -> New Detector -> Customer
     this.googleAnalyticsFunction('New Detector','Request Submitted','New Detector',jsonData.customerName+": "+jsonData.appName);
     amplitude.getInstance().logEvent("New_Detector_Request_Submitted",{ "Customer Name": jsonData.customerName, "Email": jsonData.appName  });
  
     //this.googleAnalyticsFunction('Support','New Application Request','Request Submitted -> New Detector -> '+jsonData.customerName);

    formData.append('file', this.uploadForm.get('pcapFile')!.value);
    formData.append('detector', JSON.stringify(jsonData));

    this.apiService.submitNewDetectorRequest(formData).subscribe(
      (resp) => {
        this.showsuccess = true;
        this.showSuccessMessage = JSON.parse(JSON.stringify(resp)).message;
        this.uploadForm.reset();
        this.uploadForm.controls.userName.setValue(localStorage.getItem('NAME'));
        this.uploadForm.controls.userEmail.setValue(localStorage.getItem('EMAIL'));
        this.submitted = false;

      },
      (error) => {
        // Error callback
        this.showerror = true;
        this.showErrorMessage = error.error;
      }
    );
  }
  get f() {
    return this.uploadForm.controls;
  }

  closeSuccess() {
    this.showsuccess = false;
  }

  closeError() {
    this.showerror = false;
  }

  createForm() {
    this.uploadForm = new FormGroup({

      userName: new FormControl(localStorage.getItem('NAME')),
      userEmail: new FormControl(localStorage.getItem('EMAIL')),
      appName: new FormControl('', [Validators.required,Validators.maxLength(75)]),
      detectorType: new FormControl('', [Validators.required,Validators.maxLength(45)]),
      appDescription: new FormControl('', Validators.required),
      purposeOfDetector: new FormControl(''),
      operatingSystem: new FormControl('',Validators.maxLength(45)),
      appPorts: new FormControl('',Validators.maxLength(45)),
      usesSSL: new FormControl(false),
      requireDecryption: new FormControl(false),
      onlineReferences: new FormControl('',Validators.maxLength(255)),
      pcapFile: new FormControl(''),
      customerName: new FormControl(''),
    });
  }

}
